"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMachineConfig = useMachineConfig;
const react_1 = require("react");
const useMachineConfigContext_1 = require("../context/useMachineConfigContext");
function useMachineConfig(machineId) {
    const { getMachineConfig, updateMachineConfig } = (0, useMachineConfigContext_1.useMachineConfigContext)();
    const [machineConfig, setMachineConfig] = (0, react_1.useState)(null);
    const [localConfig, setLocalConfig] = (0, react_1.useState)(null);
    const [loadingConfig, setLoadingConfig] = (0, react_1.useState)(true);
    const [saving, setSaving] = (0, react_1.useState)(false);
    const loadConfig = (0, react_1.useCallback)(async () => {
        setLoadingConfig(true);
        const config = await getMachineConfig(machineId);
        setMachineConfig(config);
        setLocalConfig(config);
        setLoadingConfig(false);
    }, [getMachineConfig, machineId]);
    (0, react_1.useEffect)(() => {
        loadConfig();
    }, [loadConfig]);
    const updateLocalConfig = (0, react_1.useCallback)((updater) => {
        setLocalConfig((prev) => (prev ? updater(prev) : prev));
    }, []);
    const saveConfig = (0, react_1.useCallback)(async () => {
        if (!localConfig)
            return;
        setSaving(true);
        try {
            const updated = await updateMachineConfig(machineId, localConfig);
            setMachineConfig(updated);
            setLocalConfig(updated);
            return true;
        }
        catch {
            return false;
        }
        finally {
            setSaving(false);
        }
    }, [updateMachineConfig, machineId, localConfig]);
    const resetConfig = (0, react_1.useCallback)(() => {
        setLocalConfig(machineConfig);
    }, [machineConfig]);
    const hasChanges = JSON.stringify(localConfig) !== JSON.stringify(machineConfig);
    return {
        config: localConfig,
        loadingConfig,
        saving,
        hasChanges,
        updateLocalConfig,
        saveConfig,
        resetConfig,
    };
}
